module.exports = __webpack_public_path__ + "4716f1e934badbb033c583a73af4dacc.svg";